import { makeStyles } from '@mui/styles';

const styles = makeStyles(() => ({
  pickerControl: {
    minWidth: 'unset',
  },
}));

export default styles;
